export { default as ExclamationCircleIcon } from './ExclamationCircleIcon';
